<template>
  <div :class="{'mobile_record': !isInBox }">
    <record-info :record="record" hide-icons></record-info>

    <record-next-contact
      v-if="showNextContact"
      class="mt-100"
      :record="record"
      hide-one-hour
      hide-input
      remove-flex-between
    ></record-next-contact>

    <div v-if="contact" class="contact">
      <sensitive-data-wrapper @click="openContactModal">
        <h3 class="contact--name" @click="openContactModal">{{ contact.full_name }}</h3>
      </sensitive-data-wrapper>

      <p class="contact--info">
        <sensitive-data-wrapper>
          <span v-if="contact.email_address">{{ contact.email_address }}</span>
          <span v-if="contact.email_address && contact.phone_1"> | </span>
          <span v-if="contact.phone_1">{{ $utils.formatNumber(contact.phone_1) }}</span>
        </sensitive-data-wrapper>
      </p>
    </div>

    <comm-buttons
      v-if="contact"
      :contact="contact"
      :record="record"
      include-button-text
      class="mt-50"
      size="is-small"
    ></comm-buttons>
  </div>
</template>

<script>
import CommButtons from "../../../components/comms/CommButtons";
import router from "../../../router";
import SensitiveDataWrapper from "../../../components/SensitiveDataWrapper.vue";

export default {
  name: "MobileRecordItem",
  components: {SensitiveDataWrapper, CommButtons},
  props: {
    record: {
      type: Object,
      required: true
    },
    showNextContact: {
      type: Boolean,
      default: false,
    },
    isInBox: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    contact() {
      if(! this.record.contact) return null;

      let contact = this.record.contact;
      contact.full_name = contact.first_name + ' ' + contact.last_name;
      return contact;
    },
  },
  methods: {
    openContactModal() {
      router.replace({query: {contact: this.contact.id}});
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.mobile_record {
  margin-bottom: 12px;
  padding-bottom: 12px;

  &:not(:last-child) {
    border-bottom: 1px solid $border;
  }
}

.contact {
  margin-top: 12px;

  &--name {
    color: $link;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      color: $link-hover;
    }
  }

  &--info {
    margin-top: 4px;
    font-size: 0.875rem;
  }
}
</style>
